import { UPDATE_FORM_ONE, DELETE_FORM_ONE } from './types';


export function FormOneReducer(state, action) {

    const { payload, type } = action


    switch (type) {

        case UPDATE_FORM_ONE:
            return {
                ...state,
                formOne: payload
            }

        case DELETE_FORM_ONE:
            return {
                ...state,
                formOne: payload
            }
        default:
            break;
    }

} 